import { ChevronRight } from 'lucide-react'

export interface CollapsibleReferenceProps {
  label: string
  content?: string
  isLoading?: boolean
  isError?: boolean
  emptyText?: string
}

// A collapsed-by-default, read-only reference block - Design PRD 10's
// "Extractor default" (product-level) and "Baseline prompt" (document-level)
// blocks are explicitly "the same" pattern, so this is one shared component
// rather than two near-duplicates. No existing shared component covers this
// (no Collapsible/Accordion primitive exists elsewhere in this app).
export function CollapsibleReference({
  label,
  content,
  isLoading,
  isError,
  emptyText = 'Nothing to show yet.',
}: CollapsibleReferenceProps) {
  return (
    <details className="group rounded-control border border-border bg-surface-raised">
      <summary className="flex cursor-pointer list-none items-center gap-1 px-3 py-2 text-meta font-medium text-text-secondary">
        <ChevronRight size={14} strokeWidth={1.5} className="shrink-0 transition-transform group-open:rotate-90" />
        {label}
      </summary>
      <div className="border-t border-border px-3 py-2 text-body text-text-primary">
        {isLoading && <span className="text-text-secondary">Loading…</span>}
        {!isLoading && isError && <span className="text-danger">Failed to load.</span>}
        {!isLoading && !isError && (
          <pre className="whitespace-pre-wrap break-words font-mono text-meta text-text-primary">
            {content && content.length > 0 ? content : <span className="text-text-disabled">{emptyText}</span>}
          </pre>
        )}
      </div>
    </details>
  )
}
